const getters = {
  sidebar: state => state.app.sidebar,
  token: state => state.user.token,
  id: state => state.user.id,
  userinfo: state => state.user.userinfo,
  roles: state => state.user.roles,
  enable: state => state.user.enable,
  deleted: state => state.user.deleted,
  name: state => state.user.userinfo.operator_account_user_name ? state.user.userinfo.operator_account_user_name : state.user.userinfo.user_name,
  imtoken: state => state.user.userinfo.im_token,
  imid: state => state.user.userinfo.im_id,
  receipt_address_count: state => state.user.userinfo.receipt_address_count,
  is_operator_account: state => state.user.userinfo.role ? true : false,  // 是否是运营账号
}
export default getters
